import supabase from "artifact/supabase";
import connected from "standard/connected";
import define from "standard/define";
import on from "standard/on";
import paint from "standard/paint";
import trait from "standard/trait";
import style from "./style";

@define("m-activity-delete")
class Delete extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @connected
  @paint
  [trait.template]() {
    return `
      <figure class='${style.delete}'>
        <span class='${style.delete__file}'>
          ${this.dataset.activity} 
        </span>
        <img
          class='${style.delete__img}'
          alt='Excluir' 
          src='//donna.sistemadulino.com.br/delete.png' 
          loading='eager' 
        />
      </figure>
    `;
  }

  @connected
  async [trait.toggle]() {
    /true|yes/.test(this.dataset.completed) && this.remove();
    return this;
  }

  @on.click("img")
  async [trait.onClick]() {
    await supabase.storage
      .from("activities")
      .remove(`${this.dataset.activity}/${this.dataset.user}`);

    await supabase
      .from("activity_completed")
      .delete()
      .eq("activity_id", this.dataset.activity)
      .eq("user_id", this.dataset.user);

    location.reload();
  }
}

export default Delete;
